import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0C4652',
      light: '#1B9DB8',
      dark: '#083840',
      contrastText: '#fff',
    },
    secondary: {
      main: '#ABBD23',
      light: '#C5D64A',
      dark: '#8A9919',
      contrastText: '#fff',
    },
    text: {
      primary: '#1A1A1A',
      secondary: '#484848',
    },
    background: {
      default: '#fff',
      paper: '#f8f9fa',
    },
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '64px',
      lineHeight: 1.2,
      '@media (max-width:992px)': {
        fontSize: '52px',
      },
      '@media (max-width:768px)': {
        fontSize: '36px',
      },
      '@media (max-width:480px)': {
        fontSize: '32px',
      },
    },
    h2: {
      fontWeight: 700,
      fontSize: '48px',
      lineHeight: 1.3,
      '@media (max-width:992px)': {
        fontSize: '38px',
      },
      '@media (max-width:768px)': {
        fontSize: '28px',
      },
      '@media (max-width:480px)': {
        fontSize: '24px',
      },
    },
    h3: {
      fontWeight: 700,
      fontSize: '32px',
      lineHeight: 1.3,
      '@media (max-width:992px)': {
        fontSize: '28px',
      },
      '@media (max-width:768px)': {
        fontSize: '22px',
      },
    },
    h4: {
      fontWeight: 600,
      fontSize: '24px',
      lineHeight: 1.4,
      '@media (max-width:768px)': {
        fontSize: '18px',
      },
    },
    body1: {
      fontSize: '16px',
      lineHeight: 1.6,
      '@media (max-width:768px)': {
        fontSize: '15px',
        lineHeight: 1.5,
      },
    },
    body2: {
      fontSize: '14px',
      lineHeight: 1.5,
    },
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 30,
          padding: '12px 24px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
          },
          '@media (max-width:768px)': {
            padding: '10px 20px',
            fontSize: '14px',
          },
        },
        containedPrimary: {
          backgroundColor: '#0C4652',
          '&:hover': {
            backgroundColor: '#1B9DB8',
          },
        },
        containedSecondary: {
          backgroundColor: '#ABBD23',
          '&:hover': {
            backgroundColor: '#8A9919',
          },
        },
        outlinedPrimary: {
          borderColor: '#D9D9D9',
          color: '#000',
          '&:hover': {
            backgroundColor: '#f5f5f5',
            borderColor: '#D9D9D9',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 25,
            '& fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.1)',
            },
            '&:hover fieldset': {
              borderColor: 'rgba(0, 0, 0, 0.2)',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#ABBD23',
            },
          },
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          borderRadius: 0,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        paper: {
          borderRadius: 8,
          boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontFamily: '"Montserrat", sans-serif',
          fontSize: '14px',
          padding: '10px 16px',
        },
      },
    },
  },
});

export default theme;
